import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ListHeaderContainer,
  PaginationContainer,
  TableContainer,
} from "../../../../containers";
import { filterObjectKeys } from "../../../../helpers";
import { getListEnvironment } from "../../../../store/environment/thunks";
import { LoadingComponent } from "../../../../components";

const URL = "configuracion/variables-de-entorno";
const dataInput = { id: "searchEnvironment", placeholder: "Buscar variable" };
const allowedKeys = ["id", "key", "value"];
const dataHeader = {
  title: "Variables de Entornos",
  nameButton: "Crear Variable",
  url: "",
};

export const SettingEnvironmentIndexPage = () => {
  const { environmentData, showLoading } = useSelector(
    (state) => state.listEnvironment
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const serachParams = new URLSearchParams(search);
  const pageEnviroment = serachParams.get("page");
  const searchEnviroment = serachParams.get("search");
  let enviromentParams = {
    page_size: 20,
    page: pageEnviroment ?? 1,
    search: searchEnviroment ?? "",
  };

  useEffect(() => {
    dispatch(getListEnvironment(enviromentParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageEnviroment, searchEnviroment]);

  const filter = () => {
    const searchValue = document.getElementById("searchEnvironment").value;
    if (searchValue === "") {
      dispatch(getListEnvironment());
      navigate("/" + URL);
      return;
    }
    const searchUrl = `/configuracion/variables-de-entorno?search=${searchValue}`;
    navigate(searchUrl);
  };

  const handleKeyDown = (e) => {
    const searchValue = document.getElementById("searchEnvironment").value;
    if (e.key === "Backspace" && searchValue.length === 1) {
      dispatch(getListEnvironment());
      navigate("/" + URL);
    }
    if (e.key !== "Enter") return;
    filter();
  };

  const getUrl = (id) => {
    return `/configuracion/variables-de-entorno/${id}/detalles`;
  };

  const newData = environmentData?.results?.map((obj) =>
    filterObjectKeys(obj, allowedKeys)
  );

  return (
    <section className="clientIndexPage">
      <ListHeaderContainer data={dataHeader} addButton={false} />
      {!showLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <TableContainer
            filter={filter}
            handleKeyDown={handleKeyDown}
            dataInput={dataInput}
            data={newData}
            url={getUrl}
            titles={allowedKeys}
            isFilter={false}
          />
          <PaginationContainer data={environmentData} />
        </>
      )}
    </section>
  );
};
